import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS, PAGES_ROUTES, PAGES_TITLE } from "utils/Constants";
import { Linking, StyleSheet, View } from "react-native";
import { fp, spH, spV, wp } from "utils/normalise";

import Buttons from "../src/components/Buttons";
import ParentScrollView from "components/ParentScrollView";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { logEvent } from "firebase/analytics";
import { useEffect } from "react";
import Heading from "components/Heading";
import { Pharagraph } from "components/Pharagraph";

export default function ContactUs() {
    useEffect(() => {
        logEvent(analytics, FIREBASE_EVENT_NAMES.PAGE_VIEW, {
            [FIREBASE_EVENT_PARAMS.PAGE_TITLE]: PAGES_TITLE.CONTACT_US,
            [FIREBASE_EVENT_PARAMS.PAGE_LOCATION]: PAGES_ROUTES.CONTACT_US,
        });
    }, []);

    return (
        <ParentScrollView>
            <View style={styles.container}>
                <View
                    style={{
                        ...styles.aboutTextContainer,
                        // marginTop: spV(80),
                        width: wp(720),
                    }}
                >
                    <Heading type="h1" style={styles.aboutHeadingText}>The Future of Personal Retail</Heading>
                    <VText style={styles.aboutSubText}>
                        The only smart shopping platform that empowers the luxury experience through technology,
                        stylists and brands in one personalized smart shopping experience.
                    </VText>
                    <View style={{ marginTop: spV(20) }}>
                        <Buttons
                            fontSize={18}
                            containerStyle={{
                                borderRadius: 4,
                                marginTop: 16,
                                padding: 16,
                                width: wp(500),
                                backgroundColor: "#000000",
                            }}
                            text="Download App Now"
                            onPress={() => {
                                Linking.openURL("https://apps.apple.com/in/app/v%C3%AAtir/id6444030686");
                            }}
                        />
                    </View>
                </View>
                <View style={{ ...styles.aboutTextContainer, marginTop: spV(60) }}>
                    <VText style={styles.aboutSubText}>
                        To learn more or inquire about ways to partner with us please email:
                    </VText>
                    <View style={styles.emailContainer}>
                        <VText style={styles.emailTitleText}>Designers</VText>
                        <VText
                            style={styles.emailText}
                            onPress={() => {
                                Linking.openURL("mailto:designer@vetirapp.com");
                            }}
                        >
                            Designer@vetirapp.com
                        </VText>
                    </View>
                    <View style={styles.emailContainer}>
                        <VText style={styles.emailTitleText}>Stylists</VText>
                        <VText
                            style={styles.emailText}
                            onPress={() => {
                                Linking.openURL("mailto:stylist@vetirapp.com");
                            }}
                        >
                            Stylist@vetirapp.com
                        </VText>
                    </View>
                    <View style={{ ...styles.emailContainer, borderBottomWidth: 0 }}>
                        <VText style={styles.emailTitleText}>Private clients</VText>
                        <VText
                            style={styles.emailText}
                            onPress={() => {
                                Linking.openURL("mailto:concierge@vetirapp.com");
                            }}
                        >
                            Concierge@vetirapp.com
                        </VText>
                    </View>
                </View>
            </View>
        </ParentScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
        paddingBottom: spV(40),
        width: "auto",
        alignItems: "center",
        marginTop: spV(32),
    },
    aboutTextContainer: {
        alignItems: "center",
        // marginTop: spV(60),
        // marginTop: spV(20),
        marginLeft: spH(10),
        marginRight: spH(10),
    },
    aboutHeadingText: {
        textAlign: "center",
        fontSize: fp(28),
        fontFamily: "LibreBodoni",
        fontWeight: "350",
    },
    aboutSubText: {
        marginTop: spV(16),
        fontSize: fp(16),
        fontWeight: "350",
        lineHeight: 24,
        textAlign: "center",
    },
    emailContainer: {
        marginTop: spV(10),
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: wp(720),
        borderBottomColor: "#000000",
        borderBottomWidth: 1,
        paddingTop: spV(10),
        paddingBottom: spV(8),
    },
    emailTitleText: {
        fontSize: fp(16),
        fontWeight: "450",
        lineHeight: 16,
        textAlign: "left",
    },
    emailText: {
        fontSize: fp(16),
        fontWeight: "350",
        lineHeight: 24,
        textAlign: "left",
    },
});
